@if (isLoggedIn()) {
  <app-header></app-header>
}
@if (isLoggedIn() && isMobile() && sidebarOpen()) {
  <button
    type="button"
    class="app-sidebar-backdrop fixed inset-0 top-[72px] z-[9] border-0 bg-slate-900/40 p-0"
    (click)="closeSidebar()"
    [attr.aria-label]="'Close menu'"
  ></button>
}
<main
  class="min-h-screen bg-surface transition-[margin] duration-300"
  [class.pt-[72px]]="isLoggedIn()"
  [class.ms-0]="!isLoggedIn() || isMobile()"
  [class.ms-[var(--spacing-sidebar)]]="isLoggedIn() && !isMobile()"
>
  @if (isLoggedIn()) {
    <app-side-nav></app-side-nav>
  }
  <div class="p-4 md:p-5">
    <router-outlet></router-outlet>
  </div>
</main>
@if (isLoading()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/20">
    <svg class="h-16 w-16 animate-spin text-primary-500" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="opacity-25" fill="none" stroke="currentColor" stroke-width="6" cx="33" cy="33" r="30"></circle>
      <path class="opacity-75" fill="currentColor" d="M33 3a30 30 0 0 1 0 60"></path>
    </svg>
  </div>
}
